import React, { useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { pastorInfo } from "../data/siteContent";
import styles from "./PastorBio.module.css";

const PastorBio = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div id="pastor" data-aos="fade-up">
      <Container className={`py-5 ${styles.container}`}>
        <Row className="mb-4">
          <Col className="text-center">
            <h1 className={styles.title}>Meet Our Pastor</h1>
            <p className={styles.subtitle}>Dedicated to faith, service, and community.</p>
          </Col>
        </Row>

        <Row className="align-items-center">
          <Col md={4} className="text-center">
            <img
              src={pastorInfo.image}
              alt={`${pastorInfo.name} - ${pastorInfo.title}`}
              className={`img-fluid rounded-circle ${styles.image}`}
              style={{ opacity: imageLoaded ? 1 : 0.5, transition: "opacity 0.3s ease" }}
              onLoad={() => setImageLoaded(true)}
            />
          </Col>

          <Col md={8}>
            <Card className={styles.bioCard}>
              <Card.Body>
                {pastorInfo.bio.map((paragraph, index) => (
                  <Card.Text key={index} className={styles.bioText}>
                    {index === 0 && (
                      <>
                        <strong className={styles.name}>{pastorInfo.name}</strong>
                        {paragraph.substring(pastorInfo.name.length)}
                      </>
                    )}
                    {index !== 0 && paragraph}
                  </Card.Text>
                ))}
                <Button href="#contact" className={styles.btn}>
                  Contact Pastor
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className={styles.quoteSection}>
          <Col>
            <h2 className={styles.quoteTitle}>Words from Our Pastor</h2>
            <p className={styles.quote}>"{pastorInfo.quote}"</p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PastorBio;
